import { Outlet } from '@tanstack/react-router';

import { SystemMark } from '@/components/system-mark';

/**
 * The shell the sign-in page wears while the storefront is closed.
 *
 * `StoreLayout` puts `SiteHeader` and `SiteFooter` around its pages, and both
 * are wrong here: the header's nav points at Shop, Custom order and Orders,
 * which now redirect back to this page, and the footer advertises a store
 * nobody can enter. A menu of dead ends is worse than no menu.
 *
 * So: the mark, and the page. Nothing else. While the shop is closed only
 * staff sign in here, so the mark is the system's, ESSE, not the shop's.
 *
 * The wordmark points at the sign-in page rather than at `/`. Its default is
 * `/`, which redirects straight back here while the store is closed: one extra
 * navigation to arrive where you already were. See `storefront.ts`.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-[100dvh] flex-col">
      <header className="border-b border-line">
        <div className="mx-auto flex h-[68px] max-w-[1180px] items-center px-[30px]">
          <SystemMark href="/auth/sign-in" />
        </div>
      </header>
      <main id="main" className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
